import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popupselect',
  templateUrl: './popupselect.component.html',
  styleUrls: ['./popupselect.component.scss']
})
export class PopupselectComponent {
  isMultiple = false; // Flag to toggle between single and multiple selection
  selectedItems: any[] = []; // Stores selected items
  searchitem:any
  itemlistArray:any
  heading:any
  selecttype:any
  constructor(
    public dialogRef: MatDialogRef<PopupselectComponent>,
    // public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ){}

   ngOnInit() {
      this.itemlistArray=this.data.itemlist
      this.heading=this.data.heading
   this.isMultiple=this.data.ismultiple
    }
  // selectItem(item:any){
  //   this.dialogRef.close(item)
  // }
 // Check if an item is selected
 isSelected(item: any): boolean {
  return this.selectedItems.some((selected) => selected.id === item.id);
}

// Handle single item selection
selectItem(item: any) {
  if (!this.isMultiple) {
    this.selectedItems = item;
console.log(this.selectedItems);
this.onSubmit()

  }
}

onSubmit(){
  if (!this.isMultiple) {
    this.dialogRef.close(this.selectedItems)

    console.log(this.selectedItems);
    
  }
  else{
    this.dialogRef.close(this.selectedItems)
console.log(this.selectedItems);

  }
}

// Toggle multiple item selection
toggleSelection(item: any) {
  const index = this.selectedItems.findIndex((selected) => selected.id === item.id);
  if (index > -1) {
    // Item already selected: Remove it
    this.selectedItems.splice(index, 1);
  } else {
    // Item not selected: Add it
    this.selectedItems.push(item);
  }
}

// // Toggle between single and multiple selection modes
// toggleSelectionMode() {
//   this.isMultiple = !this.isMultiple;

//   // Reset selection when switching to single mode
//   if (!this.isMultiple && this.selectedItems.length > 1) {
//     this.selectedItems = this.selectedItems.slice(0, 1); // Keep only the first selected item
//   }
// }
}
